<template>
  <blank-view>
    <div slot="action" style="display: flex; align-items: center; justify-content: space-between">
      <div>
        <a-button v-acl="'page_alarm_export'" @click="exportAlarmHistory">
            {{ $t('export') }}
        </a-button>
      </div>
    </div>
    <div style="display: flex; flex-wrap: nowrap; height: 100%">
      <div class="custom-list">
        <ml-table
          :columns="columns"
          :dataSource="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          size="small"
          :pagination="false"
          :selectRowKey="selectedRow && selectedRow.key"
          :scroll="{ y: scrollY }"
          :customRow="
            (row) => ({
              on: {
                click: () => {
                  clickRow(row);
                },
              },
            })
          "
        >
        </ml-table>
        <a-pagination
          style="position: absolute; bottom: 4px; right: 20px"
          :total="total"
          :pageSize="filters.size"
          :current="filters.current"
          :show-total="(total) => `${showTotal(total)}`"
          @change="pageIndexchange"
        ></a-pagination>
      </div>
      <div class="custom-detail">
        <alarm-detail
          :knowledge="selectedRow"
          class="knowledge-detail"
        ></alarm-detail>
      </div>
    </div>
  </blank-view>
</template>

<script>
import dayjs from "dayjs";
import AlarmDetail from "./alarmDetail";
import { CustomerServiceProxy } from "@/service-proxies/app-v2/client.service-proxies";
import { exportAlarmHistory } from "@/api/api";
const csp = new CustomerServiceProxy();

export default {
  components: {
    AlarmDetail,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    advance: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    dataSource: {
      handler() {
        if (!(this.dataSource && this.dataSource.length)) {
          this.selectedRow = {};
          this.selectedRowKeys = [];
          this.scrollY = 0;
          return;
        }
        this.getScroll();
        if (JSON.stringify(this.selectedRow) === "{}") {
          this.selectedRow = this.dataSource[0];
          this.selectedRowKeys = [this.dataSource[0].key];
        } else {
          const item = this.dataSource.find(
            (res) => res.key === this.selectedRow.key
          );
          if (!item) {
            this.selectedRow = this.dataSource[0];
            this.selectedRowKeys = [this.dataSource[0].key];
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selectedRow: {}, // 编辑数据
      selectedRowKeys: [], // 选中ids
      scrollY: 0,
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("page_alarm_alarmmsg"),
          dataIndex: "issueCode",
          key: "issueCode",
          ellipsis: true,
          customRender: (text, record) => {
            return (
              <a-tooltip>
                <template slot="title">{record.alarmMessage}</template>
                <a-tag color="green">{text}</a-tag>
                {record.alarmMessage}
              </a-tooltip>
            );
          },
        },
        {
          title: this.$t("page_mdc_machine"),
          dataIndex: "workStationName",
          key: "workStationName",
          ellipsis: true,
          customRender: (text, record) => {
            return (
              <a-tooltip>
                {text} ({record.serialNo})
              </a-tooltip>
            );
          },
        },
        {
          title: this.$t("page_mdc_customer_name"),
          dataIndex: "customerName",
          key: "customerName",
          ellipsis: true,
        },
        {
          title: this.$t("page_alarm_alarmtime"),
          dataIndex: "alarmTime",
          key: "alarmTime",
          ellipsis: true,
          customRender: (text) => {
            return text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
      ];
    },
  },
  methods: {
    getScroll() {
      const devCol = document.documentElement;
      const scrollY = devCol.clientHeight - 210;
      const lengthHieght = this.dataSource.length * 35;
      if (scrollY < lengthHieght) {
        this.scrollY = scrollY;
      }
    },
    pageIndexchange(value) {
      this.$emit("pageIndexchange", value);
    },
    showTotal(total) {
      return this.$t("Total…items").replace("{0}", total);
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys;
    },
    clickRow(row) {
      this.selectedRow = row;
      this.selectedRowKeys = [row.key];
    },
    exportAlarmHistory() {
      this.advance.idList = this.selectedRowKeys.map(x=>x.split('/')[0])
      exportAlarmHistory(this.advance).then((res) => {
        // 创建隐藏的可下载链接
        var a = document.createElement("a")
        a.download = `${this.$t('page_alarm_alarm_history')}.xlsx`
        a.style.display = "none"
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      });
    }
  },
};
</script>

<style lang="less" scoped>
.exception {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 240px;
  .text {
    padding: 24px;
    p {
      font-size: 20px;
    }
  }
}
.custom-list {
  width: 650px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 650px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: hidden;
}
</style>
